import { useDrag, ConnectDragPreview, ConnectDragSource } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { DragSourceType, EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import * as Models from 'models';
import { isModuleBundle } from 'utils/entityType';

type Props = {
  document: Models.AssetsCollectionMap;
  screen: Models.ScreenMap;
  screenOrder: number;
};

type AssetsCollectionScreenDragSourceHook = {
  isDragging: boolean;
  draggable: boolean;
  connectDragSource: ConnectDragSource;
  connectDragPreview: ConnectDragPreview;
};

export const useAssetsCollectionScreenDragSource = (props: Props): AssetsCollectionScreenDragSourceHook => {
  const dispatch = useDispatch();
  const dragSourceType = DragSourceType.STORY_CARD;
  const componentType = EntityType.STORY_CARD;
  const { document, screenOrder, screen } = props;
  const [{ isDragging, draggable }, connectDragSource, connectDragPreview] =
    useDrag<Models.StoryCardDragObject, void, { isDragging: boolean; draggable: boolean }>({
      type: dragSourceType,
      item: () => {
        dispatch(toggleDragState(dragSourceType, componentType));

        return {
          storyCardId: (document as unknown as Models.DocumentMap).get('id'),
          screenOrder,
          screenName: screen.get('name'),
          previewUrl: screen.getIn(['thumbnail', 'url']),
        };
      },
      canDrag() {
        return !isModuleBundle(document);
      },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
        draggable: monitor.canDrag(),
      }),
      end() {
        dispatch(toggleDragState());
      },
    });

  return { isDragging, draggable, connectDragSource, connectDragPreview };
};
